export default "__VITE_ASSET__f5e38e28__"